import { ADD_TO_WATCHLIST, REMOVE_FROM_WATCHLIST } from '../../constants';

const WATCHLIST_URL = '/area-privata/watchlist';
const WATCHLIST_QUEUE = 'watchlist-queue';

export default class WatchlistButton {

    constructor(element, adId, executeOnRefresh, operation) {
        this.$element = $(element);
        this.adId = adId;
        this.executeOnRefresh = executeOnRefresh;
        this.operation = operation;
    }

    clickButton() {
        if(this.executeOnRefresh) {
            // store in queue
            this.addToWatchlistQueue(this.adId);
        } else {
            switch (this.operation) {
            case 'save':
                this.saveAd(this.adId);
                break;
            case 'remove':
                this.removeAd(this.adId);
                break;
            }
        }
    };

    init() {
        this.$element.off('click').on('click', $.proxy(this, 'clickButton'));
    }

    addToWatchlistQueue(adId) {
        let obj = {
            'endpoint': WATCHLIST_URL,
            'objId': adId,
            'operation': this.operation,
            'gtm':  { eventName: 'WatchlistAddSuccess', eventLabel: '' } ,
            'dom': {
                'show': 'remove-' + adId,
                'hide': 'save-' + adId
            }
        };

        try {
            let queue = JSON.parse(localStorage.getItem(WATCHLIST_QUEUE)) || [];
            queue.push(obj);
            localStorage.setItem(WATCHLIST_QUEUE, JSON.stringify(queue));
        } catch (error) {
            console.error('ERROR: ' + JSON.stringify(error));
        }
    }

    saveAd(adId) {
        var that = this;
        this.$element.off('click');
        $.ajax({
            type: 'post',
            url: WATCHLIST_URL,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            headers: {
                'X-CSRF-Token': $('meta[name="_csrf"]').attr('content')
            },
            data: JSON.stringify({'id' : adId }),
            beforeSend: () => {
                that.$element.toggleClass('hidden');
                that.$element.siblings().toggleClass('hidden');
            },
            success: (result) => {

            },
            error: (xhr, status, error) => {
                that.$element.toggleClass('hidden');
                that.$element.siblings().toggleClass('hidden');
            },
            statusCode: {
                201: function() {
                    that.addToWatchilstCstEvt(); // dispatch addToWatchlist custom event
                    that.$element.toggleClass('hidden');
                    that.$element.siblings().toggleClass('hidden');

                }
            },
            complete: function() {
                that.$element.on('click', $.proxy(that, 'clickButton'));
            }
        });
    }

    removeAd(adId) {
        if(this.$element.data('hide-element')) {
            $('article#' + adId).fadeOut();
        }
        var that = this;
        $.ajax({
            type: 'delete',
            url: WATCHLIST_URL + '/' + this.adId,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            headers: {
                'X-CSRF-Token': $('meta[name="_csrf"]').attr('content')
            },
            data: JSON.stringify({'id' : adId }),
            beforeSend: () => {
                that.$element.toggleClass('hidden');
                that.$element.siblings().toggleClass('hidden');
            },
            success: () => {

            },
            error: () => {
                that.$element.toggleClass('hidden');
                that.$element.siblings().toggleClass('hidden');
            },
            statusCode: {
                201: function() {
                    that.removeFromWatchilstCstEvt(); // dispatch removeFromWatchlist custom event
                    that.$element.toggleClass('hidden');
                    that.$element.siblings().toggleClass('hidden');
                }
            },
            complete: function() {
                that.$element.off('click').on('click', $.proxy(that, 'clickButton'));
            }
        });
    }

    addToWatchilstCstEvt() {
        const event = new CustomEvent(ADD_TO_WATCHLIST);
        document.dispatchEvent(event);
    }

    removeFromWatchilstCstEvt() {
        const event = new CustomEvent(REMOVE_FROM_WATCHLIST);
        document.dispatchEvent(event);
    }
}
